import { t } from '@lingui/macro';

import CaretDown from '@decisiv/iconix/lib/components/CaretDown';
import Plus from '@decisiv/iconix/lib/components/Plus';
import Refresh from '@decisiv/iconix/lib/components/Refresh';
import Upload from '@decisiv/iconix/lib/components/Upload';

import Button from '@decisiv/ui-components/lib/components/Button';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import Menu from '@decisiv/ui-components/lib/components/Menu';
import Popover from '@decisiv/ui-components/lib/components/Popover';

import useMenuPopover from 'pages/Management/hooks/useMenuPopover';

import { MenuDivider } from './styles';

interface AddAssetMenuProps {
  disabled?: boolean;
  kind?: 'primary' | 'secondary';
  onSelectManual?: () => void;
  onSelectBulk?: () => void;
  /**
   * Switches the control to the "Manage Assets" variant: relabelled button,
   * plus a second menu below a divider. Omitted by the Accounts index header
   * button, which spans every account and so has none for a reset to target.
   */
  onSelectReset?: () => void;
}

export default function AddAssetMenu({
  disabled,
  kind = 'secondary',
  onSelectManual,
  onSelectBulk,
  onSelectReset,
}: AddAssetMenuProps) {
  const { triggerProps, popoverProps, closeOnSelect } = useMenuPopover();

  const items = closeOnSelect([
    {
      id: 'manual',
      text: t`Add Asset`,
      icon: Plus,
      disabled: !onSelectManual,
      onSelect: onSelectManual,
    },
    {
      id: 'bulk',
      text: t`Bulk Add Assets`,
      icon: Upload,
      disabled: !onSelectBulk,
      onSelect: onSelectBulk,
    },
  ]);

  const resetItems = closeOnSelect([
    {
      id: 'reset',
      text: t`Reset Depots Assets`,
      icon: Refresh,
      onSelect: onSelectReset,
    },
  ]);

  return (
    <>
      <Button
        text={onSelectReset ? t`Manage Assets` : t`Add Asset`}
        icon={CaretDown}
        iconPosition="right"
        size="small"
        kind={kind}
        disabled={disabled}
        {...triggerProps}
      />
      <Popover {...popoverProps} zIndex={200}>
        <Flex flexDirection="column">
          <Menu items={items} />
          {onSelectReset && (
            <>
              <MenuDivider />
              <Menu items={resetItems} />
            </>
          )}
        </Flex>
      </Popover>
    </>
  );
}
